import { Pipe, PipeTransform } from '@angular/core';
import {
  AssessmentEmployeeStatusEnum,
  AssessmentEmployeeStatusInfo,
} from '@qaroni-app/assessment/types/assessment-employee-status.enum';

@Pipe({
  name: 'assessmentEmployeeStatus',
  standalone: false,
})
export class AssessmentEmployeeStatusPipe implements PipeTransform {
  transform(value: AssessmentEmployeeStatusEnum | string): string {
    if (
      value &&
      Object.prototype.hasOwnProperty.call(AssessmentEmployeeStatusInfo, value)
    ) {
      return AssessmentEmployeeStatusInfo[value].name;
    }

    return value;
  }
}
